import React from 'react';
import { Result } from 'antd';
import { LockOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { NS } from '../i18n';

interface PermissionDeniedProps {
  title?: string;
  message?: string;
  icon?: React.ReactNode;
}

/**
 * Inline "no permission" state for a section/module that lives inside an
 * already-navigated layout (sidebar, tabs) — unlike `Unauthorized`, it does
 * NOT redirect or leave the shell, it just replaces the module's content.
 *
 * TEMPORARY placeholder copy/visuals: design has not defined the final empty
 * state for this case yet (not in the current prototype) — swap this out
 * once that spec lands.
 */
export function PermissionDenied({
  title,
  message,
  icon = <LockOutlined style={{ fontSize: 40 }} />,
}: PermissionDeniedProps) {
  // Defaults are resolved at render, not in the signature, so they follow the
  // active language.
  const { t } = useTranslation(NS);
  return (
    <div style={{ height: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <Result
        icon={icon}
        title={title ?? t('permissionDenied.title')}
        subTitle={message ?? t('permissionDenied.message')}
      />
    </div>
  );
}
